import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useApp } from '../context/AppContext';

const { FiClock, FiPlusCircle, FiUser, FiGift, FiAirplay, FiMap, FiShare2, FiShield } = FiIcons;

export default function Navigation() {
  const { user } = useApp();

  const navItems = [
    { path: '/', icon: FiClock, label: 'Wait' },
    { path: '/flights', icon: FiAirplay, label: 'Flights' },
    { path: '/share', icon: FiShare2, label: 'Share' },
    { path: '/parking', icon: FiMap, label: 'Parking' },
    { path: '/report', icon: FiPlusCircle, label: 'Report' },
    { path: '/rewards', icon: FiGift, label: 'Rewards' },
    { 
      path: '/profile', 
      icon: FiUser, 
      label: user.isLoggedIn ? 'Profile' : 'Sign Up' 
    },
  ];

  // Add Admin tab only if user is admin
  if (user.isAdmin) {
    navItems.push({ path: '/admin', icon: FiShield, label: 'Admin' });
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-slate-950 border-t border-slate-800 pb-safe z-50 md:top-0 md:bottom-auto md:border-t-0 md:border-b">
      <div className="max-w-screen-md mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center w-full h-full space-y-1 transition-colors duration-200 ${
                  isActive ? 'text-amber-400' : 'text-slate-400 hover:text-slate-200'
                }`
              }
            >
              <SafeIcon icon={item.icon} className="text-xl" />
              <span className="text-[10px] font-medium uppercase tracking-wider">{item.label}</span>
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  );
}